import { IFilterGroup } from "../../data"

interface IQueryBase {
} 

export interface IQuery extends IQueryBase {
    id: string,
    fields: string[],
}

export interface IQueryMultiple extends IQueryBase {
    fields: string[],
    filters: IFilterGroup[],
    orderBy?: {
        fields: string[],
        descending?: boolean
    },
    pageSize?: number,
    pageNo?: number
}

export enum QueryType {
    Record,
    FirstRecord,
    MultipleRecords
} 

export interface IRecordQueryOptions {
    query: IQuery,
    queryType: QueryType.Record,
}

export interface IRecordsQueryOptions {
    query: IQueryMultiple,
    queryType: QueryType.FirstRecord | QueryType.MultipleRecords,
}

export type IQueryOptions = IRecordQueryOptions | IRecordsQueryOptions;
